<template>
    <BasicHeader pretitle="aqfer Marketing Data Platform" title="File Browser" />
    <div class="container-fluid">
        <div v-if="error" class="text-danger mb-2">
                    {{ error }}
        </div>
        <div v-if="message" class="container-fluid" >
            <div class="alert alert-secondary" role="alert">
                {{ message }}
            </div>
        </div>
        <div class="row" v-if="credentialList.length > 0 || dropDownLoading === 'credential' || selectedBucket" :class="dropDownDisable?'dropDownMenu':''">
            <div v-if="credentialOptions.length>0 || dropDownLoading=='credential'" class="col-md-6 col-lg-3 mb-2">
                <label class="form-label">Choose a Credential <span class="text-danger">&nbsp;*</span></label>
                <select v-if="selectedCredential" class="form-select form-control" @change="selectedCredential=$event.target.value" v-model="selectedCredential">
                        <option v-for="option in credentialOptions" :key="option.value" :value="option.value">
                            {{ option.label }}
                        </option>
                </select>
                <div v-else
                    class="spinner-border spinner-border-sm loader">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div v-if="bucketOptions.length>0 || dropDownLoading=='bucket'" class="col-md-6 col-lg-3 mb-2">
                <label class="form-label">Choose a bucket <span class="text-danger">&nbsp;*</span></label>
                <select v-if="selectedBucket" class="form-select form-control" @change="onSelectBucket($event.target.value)" v-model="selectedBucket">
                        <option v-for="option in bucketOptions" :key="option.value" :value="option.value">
                            {{ option.label }}
                        </option>
                </select>
                <div v-else class="spinner-border spinner-border-sm loader ">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <div class="col text-end" >
                <button style="margin-top: 28px" :disabled="loading" type="button" @click="onRefresh()" class="btn lift btn-primary float-right" ><i class="fa fa-refresh"/></button>
                &nbsp;
                <button style="margin-top: 28px" :disabled="uploadDisable" type="button" @click="showModal({ component: 'uploadFile' })" class="btn lift btn-primary float-right" ><i class="fa fa-upload"/>&nbsp;Upload</button>
            </div>
        </div>
        <div v-else-if="dropDownLoading == 'credential'" class="row">
            <div class="col-md-12">
                <div class="text-center mt-5">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <DetailFolderView v-if="!loading" />
</template>

<script>
import BasicHeader from "../../components/BasicHeader.vue";
import DetailFolderView from "./DetailFolderView.vue";
import { mapActions } from "vuex";

const SERVICE_NAME = 'surface';

export default {
    components: { BasicHeader, DetailFolderView },
    name: "FileBrowser",
    data() {
        return {
            bucketList: [],
            credentialList: [],
            loading: true,
            dropDownLoading: '',
            selectedBucket: null,
            selectedCredential: null,
            error: null,
            unmountRoute: null,
            message: null,
        };
    },
    computed: {
        bucketOptions() {
            if (this.bucketList && this.bucketList.length > 0) {
                return this.bucketList.map((bucket) => ({ label: bucket.name, value: bucket.name }));
            }
            return [];
        },
        credentialOptions() {
            return this.credentialList.map(ns => ({ label: ns, value: ns }));
        },
        uploadDisable() {
            return this.$route.matched.some(route => route.path.includes('file/')) || !this.selectedCredential || !this.selectedBucket;
        },
        dropDownDisable() {
            return this.dropDownLoading != '';
        },
        currentCid() {
            return this.$store.state.currentClient?.cid;
        }
    },
    watch: {
        credentialList(newValue) {
            let credential = null;
            if (newValue && newValue.length > 0) {
                this.selectedCredential = newValue[0];
                credential = this.selectedCredential;
            } else {
                this.selectedCredential = null;
            }
            this.$store.dispatch('amdp/setSelectedCredential', credential);
        },
        async selectedCredential(newValue) {
            this.dropDownLoading = "bucket";
            if (newValue && newValue != "") {
                this.message = null;
                this.error = null;
                this.selectedBucket = '';
                this.$store.dispatch('setBreadcrumbs', []);
                this.bucketList = [];
                this.$store.dispatch('amdp/setSelectedCredential', newValue);
                await this.fetchBucketList();
            }
        },
        currentCid(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                this.credentialList = [];
                this.selectedBucket = null;
                this.bucketList = [];
                this.error = null;
                this.message = null;
                this.$store.dispatch('setBreadcrumbs', []);
                this.$store.dispatch('amdp/setFolderPath', '');
                this.fetchNamespaces();
            }
        }
    },
    mounted() {
        this.fetchNamespaces();
    },
    methods: {
        ...mapActions({
            getServiceBucketList: "amdp/getServiceBucketList",
            getServiceNamespaces: "amdp/getServiceNamespaces",
            showModal: "showModal"
        }),
        async fetchNamespaces() {
            this.dropDownLoading = 'credential';
            this.loading = true;
            try {
                const response = await this.getServiceNamespaces(SERVICE_NAME);
                this.credentialList = response.data || [];
                if (!this.credentialList.length) {
                    this.message = 'No credentials available for service.';
                }
            } catch (e) {
                this.error = e.response?.data?.error || e.message;
            } finally {
                this.dropDownLoading = '';
                this.loading = false;
            }
        },
        async fetchBucketList(refresh = false) {
            let response;
            this.loading = true;
            this.error = null;
            if (refresh) {
                this.dropDownLoading = 'bucket';
            }
            try {
                const currentCid = this.$store.state.currentClient.cid;
                let param = {
                    serviceName: SERVICE_NAME,
                    namespace: this.selectedCredential,
                    type: "s3",
                    credential: currentCid + "." + this.selectedCredential
                };
                response = await this.getServiceBucketList(param);
            } catch (error) {
                if (error.response?.data?.error) this.error = error.response.data.error;
                else this.error = error.message;
                this.dropDownLoading = '';
                this.$store.dispatch('setBreadcrumbs', []);
                this.loading = false;
                return;
            }
            this.bucketList = response.data || [];
            if (this.bucketList.length > 0) {
                this.selectedBucket = this.$route.params.bucket || this.bucketList[0].name;
                this.onSelectBucket(this.selectedBucket);
            } else {
                this.selectedBucket = "";
                this.$store.dispatch('setBreadcrumbs', []);
                this.message = `There is no bucket for credential ${this.selectedCredential}`;
            }
            this.dropDownLoading = '';
            this.loading = false;
        },
        onSelectBucket(bucket) {
            let breadcrumbPath = [{
                name: bucket,
                route: {
                    name: "File Browser List",
                    params: {
                        bucket: `${bucket}`,
                        cid: this.$store.state.currentClient.cid,
                        serviceName: SERVICE_NAME
                    }
                }
            }];
            this.$store.dispatch('setBreadcrumbs', breadcrumbPath);
            this.$store.dispatch('amdp/setFolderPath', "");
            if (this.unmountRoute) return;
            this.$router.push({
                name: 'File Browser List',
                params: {
                    bucket: `${bucket}`,
                    cid: this.$store.state.currentClient.cid,
                    serviceName: SERVICE_NAME
                }
            });
        },
        onRefresh() {
            if (this.$store.state.breadcrumbs.length) {
                let path = this.$store.state.breadcrumbs[this.$store.state.breadcrumbs.length - 1].route;
                path.query = { refresh: Date.now() };
                this.$router.push(path);
            } else {
                this.fetchBucketList(true);
            }
        }
    },
    unmounted() {
        this.unmountRoute = true;
    }
};
</script>

<style scoped>
.loader{
    display: block!important;;
}
.dropDownMenu{
    pointer-events:none;
    opacity: 0.6;
}
</style>
